import React, { useEffect, useState } from "react";
import jwt_decode from "jwt-decode";
import parse from "html-react-parser";
import Ava1 from "../../../../../media/avatars/17-dark.png";
import { openModal } from "../../../../Library/ModalPopUp";
import AxiosLibWithHeader2 from "../../../../Library/AxiosLibWithHeader2";
import { CleansingJSON } from "../../../../Library/GlobalHelper";
import LoadingBtn from "../../../Widgets/LoadingBtn";
import { AlertNotif } from "../../../../Library/AlertNotif";

var AuthToken = localStorage.getItem("AuthToken");
const AuthDecode = AuthToken ? jwt_decode(AuthToken) : [];

export default function Notifications({ stdstatus, exept, ispopup }) {
  const [notifInfo, setNotifInfo] = useState({ loading: false, data: [], message: "" });

  const GET_SYS_PARAM = () => {
    const type_degree = stdstatus.program.id === 1 ? "bachelor" : "master";
    const param = { tipe: "pcf-information", name: type_degree };
    setNotifInfo({ loading: true, data: [], message: "" });
    var keys = {
      AppId: AuthDecode.AppID,
      AppEnv: AuthDecode.AppEnv,
      Secretkey: AuthDecode.secretkey,
    };

    const postData = {
      keys: keys,
      body: param,
    };

    AxiosLibWithHeader2(postData, "mc/api/sys-param").then((response) => {
      if (response.data) {
        const data = response.data;
        const conv = CleansingJSON(data);
        const only_regis_info = conv.filter(item => item.id === 1);
        console.log(only_regis_info);
        setNotifInfo({ message: "", loading: false, data: only_regis_info });
      } else if (response.error) {
        setNotifInfo({ data: [], loading: false, message: response.error });
      } else {
        setNotifInfo({ data: [], loading: false, message: "" });
      }
    });
  };

  useEffect(() => {
    GET_SYS_PARAM();
  }, [])

  return notifInfo.loading ? <LoadingBtn /> :
    notifInfo.message ? <AlertNotif message={notifInfo.message} /> :
      Object.values(notifInfo.data).length > 0 && (
        <div className="row">
          {notifInfo.data.map((v) =>
            exept !== v.id && (
              <div className={"col-12"}>
                <BoxNotif value={v} />
              </div>
            )
          )}
        </div>
      );
}

const BoxNotif = ({ value }) => {
  return (
    <div
      className="card card-custom card-stretch gutter-b"
      style={{ backgroundColor: "#1C325E", minHeight: "170px" }}
      key={value.id}
      title={value.title}
    >
      <div className="card-body d-flex ps-xl-15">
        <div className="m-0">
          <div className="position-relative h2 z-index-2 font-weight-bolder text-white mb-7">
            {value.title}
          </div>
          <div className="mb-3">
            <a
              href={value.link}
              className="btn btn-danger fw-bold me-2"
              target={"_blank"}
            >
              {value.id === 1 ? "Start Registration" : "Download Here"}
            </a>
          </div>
        </div>
        <img
          src={Ava1}
          alt="icon"
          className="position-absolute mr-0 bottom-0 right-0 h-150px"
        />
      </div>
    </div>
  );
};